import { useState } from "react"
import { HexMap } from "../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../Data/HexMap/HexMapModifier"
import { Note } from "../../Data/HexMap/Note"
import { All } from "../../Util/Constants/Quantities"
import { TransformTranslate } from "../../Util/Transform/Transform"
import { IntervalLines } from "../Connectors/IntervalLines"
import { HxMapGroup } from "../HxMap/HxMapGroup"

export function HexPattern(props:{width?:number, height?:number, radius?:number, hilitedNotes?:number[], selectedNotes?:number[], definedNotes?:number[], visibleLines?:number[],onNoteClick?:Function}){
    const radius:number = (props.radius) ? props.radius : 100
    const width:number = (props.width) ? props.width : radius * 2.8
    const height:number = (props.height) ? props.height : radius * 2.8
    const [offset, setOffset] = useState(0)
    const onNoteClick = (note:Note) => {
        if(props.onNoteClick){ 
            props.onNoteClick(note); 
            return
        }
        setOffset(note.params.noteIndex)
    }
    const getMap = () => {
        const params:HexMapBuilderParams = {
            rows:1, columns:1, tonic:0, radius:radius
        }
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.notes_setPrimaryLabelAsPosition([All], offset)
        if(props.hilitedNotes){
            mod.notes_setHilited(props.hilitedNotes)
        }
        if(props.selectedNotes){
            mod.notes_setSelected(props.selectedNotes)
        }
        if(props.definedNotes){
            //mod.notes_setDefined([All], false)
            mod.notes_setDefined(props.definedNotes, true, true)
        }
        return map
    }
    const map:HexMap = getMap()
    const getLineNotes = () => {
        if(props.visibleLines === undefined){
            return getMap().notes
        }
        else{
            if(props.visibleLines.length < 2){
                return []
            }
            const notes:Note[] = []
            props.visibleLines.forEach((noteIndex:number)=>{
                notes.push(map.notes[noteIndex])
            })
            return notes

        }
    }
    const getLines = () => {
        return <IntervalLines notes={getLineNotes()} displayConfig={map.params.displayConfig}/>
                    
    }
    return(
        <div className={'hex-pattern'}>    
            <svg width={width} height={height}>
                <g transform={TransformTranslate(width/2,height/2)}>
                    <HxMapGroup hexMap={map} onKeyClick={()=>{}} onNoteClick={onNoteClick}>
                        {getLines()}
                    </HxMapGroup>
                </g>
            </svg>
        </div>
    )
}